<div [ngClass]="[
		styles.loginBg,
		thumbnailUri ? '' : styles.noThumbnail
	]" vbImageLoad [bgImageUri]="thumbnailUri">
</div>

<a *ngIf="showThumbnail" [ngClass]="styles.loginWrap" (click)="onThumbnailClick()">
	<div [ngClass]="styles.playBtn">
		<div [ngClass]="styles.playBtnContent">
			<span class="glyphicons play"></span>
		</div>
	</div>
</a>

<div [ngClass]="styles.fallbackMessageWrap" *ngIf="showPopupFallback">
	<div [ngClass]="styles.fallbackMessage">
		<a [href]="fullscreenPlayerUrl" target="_blank">
			{{ 'Media_Videos_Embed_PlayerFallback' | translate }}
		</a>
	</div>
</div>

<ng-container *ngIf="showLoginForm">

	<vb-title [title]="'SignIn' | translate"></vb-title>

	<vb-auth-layout>

		<vb-loading-spinner *ngIf="status.processing" [msg]="'Loading' | translate" [size]="'large'">
		</vb-loading-spinner>

		<vb-loading-spinner *ngIf="status.loading" [msg]="'Login_LogoffMessage' | translate" [size]="'large'">
		</vb-loading-spinner>

		<form *ngIf="status.active" #loginForm="ngForm" name="loginForm" [ngClass]="authLayoutStyles.authForm" (submit)="submit()">

			<div [ngClass]="authLayoutStyles.heading">
				<h2>{{ 'SignIn' | translate }}</h2>
			</div>

			<div [ngClass]="authLayoutStyles.authMsg" *ngIf="status.statusMessage">{{ status.statusMessage }}</div>

			<div class="margin-top-20">

				<div class="margin-top-20">
					<label for="username">{{ 'Username' | translate }}</label>
					<input type="text" id="username" name="username" class="form-control theme-header-bg theme-header-txt" [placeholder]="'Username_Placeholder' | translate" [attr.aria-label]="'Username' | translate" [(ngModel)]="formData.username" vbAutoFocus required>
				</div>
				<div class="margin-top-20">
					<label for="password">{{ 'Password' | translate }}</label>
					<input type="password" id="password" name="password" class="form-control theme-header-bg theme-header-txt" [placeholder]="'Password_YourPlaceholder' | translate" [attr.aria-label]="'Password' | translate" [(ngModel)]="formData.password" required>
				</div>

				<div class="margin-top-30">
					<button type="submit" [ngClass]="authLayoutStyles.authBtn" vbBtnPrimary>
						{{ 'SignIn' | translate }}
					</button>
				</div>

				<div class="margin-top-20 float-right" *vbAuthorizationKey="'resetPassword'">
					<a class="theme-header-txt" href="#/initiate-password-reset" target="_blank">{{ 'ForgotPasswordNoQuestion' | translate }}</a>
				</div>
			</div>
		</form>

	</vb-auth-layout>

</ng-container>
